import { useState } from "react";
import { ContractDetail } from "@/components/contracts/ContractDetail";
import { InitiateCopyDialog } from "@/components/copy-operations/InitiateCopyDialog";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import type { Contract } from "@/lib/coach-manager/types";

interface ContractDetailDrawerProps {
  contract: Contract | null;
  /** The BU the contract was searched from — required to initiate a copy. */
  buInstanceId: string | null;
  onClose: () => void;
}

/** Wide right-side drawer hosting the full `ContractDetail` for whichever Contract is selected. */
export function ContractDetailDrawer({
  contract,
  buInstanceId,
  onClose,
}: ContractDetailDrawerProps) {
  const [copyDialogOpen, setCopyDialogOpen] = useState(false);

  return (
    <Sheet open={contract !== null} onOpenChange={(open) => !open && onClose()}>
      <SheetContent className="w-full overflow-y-auto sm:max-w-[80vw]">
        <SheetHeader>
          <div className="flex items-center justify-between gap-4">
            <div>
              <SheetTitle className="font-display">
                {contract ? `Contract ${contract.ContractID}` : "Contract"}
              </SheetTitle>
              <SheetDescription>Full detail, read-only.</SheetDescription>
            </div>
            {contract && buInstanceId && (
              <Button
                type="button"
                size="sm"
                onClick={() => setCopyDialogOpen(true)}
                className="mr-8 rounded-full"
              >
                Initiate Copy
              </Button>
            )}
          </div>
        </SheetHeader>
        <div className="px-4 pb-4">
          {contract && <ContractDetail key={contract.ContractID} contract={contract} />}
        </div>
      </SheetContent>
      {contract && buInstanceId && (
        <InitiateCopyDialog
          open={copyDialogOpen}
          onOpenChange={setCopyDialogOpen}
          sourceBuId={buInstanceId}
          contract={contract}
        />
      )}
    </Sheet>
  );
}
